import React from 'react';
import { Link } from 'react-router-dom';
import AboutCard from "./AboutCard ";
import CounterUp from 'react-countup';
import aboutImage from '../../assets/images/shapes/about-one-shape-1.png';
import aboutImg1 from '../../assets/images/resources/about-one-img-1.jpg';
import aboutImg2 from '../../assets/images/resources/about-one-img-2.jpg';
import { FaCamera, FaEdit, FaFilm, FaMusic, FaMagic, FaUsers } from 'react-icons/fa';

const AboutOne = ({
    className = "about-one about-two",
    tagline = "About Us",
    title = "From Learning to Real Film Production",
    
    description = "Sunrising Cinevision is a complete creative ecosystem where training meets real-world production. We offer professional courses in acting, direction, cinematography, editing, and more — along with full-scale production services including films, music videos, podcast shoots, chroma studio, and event coverage. Our mission is to turn passion into profession with real industry exposure.",

    listItems = [
        {
            icon: <FaCamera />,
            title: "Professional Shoot & Studio Experience",
        },
        {
            icon: <FaEdit />,
            title: "Editing, VFX & Post-Production",
        },
        {
            icon: <FaFilm />,
            title: "Film & Music Video Production",
        },
        {
            icon: <FaMusic />,
            title: "Podcast & Audio Production",
        },
        {
            icon: <FaMagic />,
            title: "Chroma & Creative Visual Setup",
        },
    ],

    images = {
        shapeImage: aboutImage,
        photo1: aboutImg1,
        photo2: aboutImg2,
    },

    trustedCount = 500,
    trustedText = "Students & Projects",

    linkTo = "/contact",
    buttonText = "Get Started",

    containerClass = "container",

    imgAltTexts = {
        photo1: "Film shoot setup",
        photo2: "Production studio",
    },

}) => {
    return (
        <section className={className}>
            <div className={containerClass}>
                <div className="row">
                    
                    {/* LEFT */}
                    <div className="col-xl-6">
                        <div className="about-one__left">
                            
                            <div className="text-left section-title">
                                <div className="section-title__tagline-box">
                                    <span className="section-title__tagline">{tagline}</span>
                                </div>

                                <h2 className="section-title__title">
                                    {title.split('\n').map((line, index) => (
                                        <React.Fragment key={index}>
                                            {line}
                                            <br />
                                        </React.Fragment>
                                    ))}
                                </h2>
                            </div>

                            <p className="about-one__text">{description}</p>

                            {/* LIST */}
                            <div className="about-one__list-box">
                                <div className="about-one__shape-1">
                                    <img src={images.shapeImage} alt="Decorative shape" />
                                </div>

                                <ul className="about-one__list list-unstyled">
                                    {listItems.map((item, index) => (
                                        <li key={index}>
                                            <AboutCard
                                                icon={item.icon}
                                                title={item.title}
                                            />
                                        </li>
                                    ))}
                                </ul>
                            </div>

                            <div className="about-one__btn-box">
                                <Link to={linkTo} className="thm-btn about-one__btn">
                                    {buttonText}
                                    <span />
                                </Link>
                            </div>
                        </div>
                    </div>

                    {/* RIGHT */}
                    <div className="col-xl-6">
                        <div className="about-one__right wow fadeInRight" data-wow-delay="300ms">
                            <div className="about-one__img-box">

                                <div className="about-one__img-1">
                                    <img src={images.photo1} alt={imgAltTexts.photo1} />
                                </div>

                                <div className="about-one__img-2">
                                    <img src={images.photo2} alt={imgAltTexts.photo2} />
                                </div>

                                {/* COUNTER */}
                                <div className="about-one__trusted-box d-flex align-items-center justify-content-center">
                                    
                                    <div className="about-one__trust-icon">
                                        <FaUsers className='w-20 h-20 text-white' />
                                    </div>

                                    <div className="about-one__trust-content">
                                        <div className="pt-3 about-one__trust-count count-box">
                                            <h3 className="count-text">
                                                <CounterUp end={trustedCount} />
                                                <span className="about-one__trust-plus">+</span>
                                            </h3>
                                        </div>

                                        <p className="pt-3 about-one__trust-text">
                                            {trustedText}
                                        </p>
                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default AboutOne;